import useUserModel from "./useUserModel";

export { default as apiUserModel } from "./apiUserModel";
export default useUserModel;
